import { RETURN_TYPES } from 'shipping-and-returns/constants/returnTypes'

const ROUTE_RETURN_TYPE_MATCHING_REVERSE: Partial<
	Record<RETURN_TYPES, string>
> = {
	[RETURN_TYPES.HOME_PICK_UP]: 'home-pickup',
	[RETURN_TYPES.DROPPOINT]: 'drop-point',
}

export const getReturnsUrlByReturnType = ({
	returnType,
	orderId,
	purchaseId,
}: {
	returnType: RETURN_TYPES
	orderId?: string
	purchaseId?: string
}) => {
	let url = '/my-returns'
	const returnTypeMatch = ROUTE_RETURN_TYPE_MATCHING_REVERSE[returnType]

	if (returnTypeMatch) {
		url = `${url}/${returnTypeMatch}`

		if (orderId && purchaseId) {
			url = `${url}/purchase/order?purchaseId=${purchaseId}&orderId=${orderId}`
		}
	}
	return url
}
